import { Component, Inject, OnInit, ApplicationRef, NgZone, OnDestroy } from '@angular/core';
import { AlertController, ModalController, Platform } from '@ionic/angular';
import { Router, NavigationEnd } from '@angular/router';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { NavController } from '@ionic/angular';
import { filter } from 'rxjs/operators';
import { first } from 'rxjs/operators';
import { DOCUMENT } from '@angular/common';
import { concat, interval, Subscription } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { SwUpdate } from '@angular/service-worker';
import * as moment from 'moment';
import { register } from 'swiper/element/bundle';
register();
import { Storage } from '@ionic/storage-angular';
import { ApiService } from '../app/api.service';
import { UsuarioServiceProvider, FuncionesServiceProvider,} from './service/index.providers';
import { MenuServiceProvider } from 'src/app/service/index.providers';
import { NotificacionService } from 'src/app/service/notificaciones-service/notificacion.service';
import { MultipleOptionModalComponent } from './components/multiple-option-modal/multiple-option-modal.component';
import { environment } from '../environments/environment';
import { Capacitor } from '@capacitor/core';
import { OfflineService } from './service/offline-service/offline.service';
import { ConexionServiceProvider, ConnectionStatus } from './service/conexion-service/conexion-service';
import { StorageService } from './service/storage-service/storage-service.service';
import { SplashScreen } from '@capacitor/splash-screen';
import { Browser } from '@capacitor/browser';
import { DownloadFileService } from './service/download-files-service/download-file.service';
import { EchoService } from './service/echo-service/echo.service';
import { LanguageService } from './service/language-service/language.service';
import { SyncService } from './service/offline-service/sync_checklist.service';
import { LoginMultiModuloService } from './service/login-multi-modulo/login-multi-modulo.service';
import { AppPlatformService } from './service/platform/app-platform.service';
import { KeyboardService } from './service/keyboard/keyboard.service';
import { OrientationService } from './service/orientation/orientation.service';
import { CapacitorSafeService } from './service/iframe-in-app/capacitor-safe.service';
declare var cordova: any;
declare const gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit , OnDestroy{
  public rootPage: any;
  fullscreen: boolean = false;
  userID: any = null;
  domain: any = null;
  platformIsIOS: boolean | null = null;
  showImpersonationBar: boolean = false;
  impersonationBarTitle: string = "";

  config_empresa: any = null;
  showNotification: boolean = false;
  showNotificationFrom: string = "";
  data_usuario: any;
  initials:any;
  userFullName: string = '';
  checkUpdateInterval;
  webCurrentVersion:any;
  webAvailableVersion:any;
  userIsLogged = false;

  //**config Cursalab del espacio multimarca**
  defaultConfigData = {
    color_primario_app: '#5458e9',
    color_secundario_app: '#58c1e5',
    color_terciario_app: '#372db4',
    titulo_login_app: 'Bienvenido a',
    subtitulo_login_app: 'Cursalab',
    logo_cursalab_position: 'top-left',
    form_login_position: 'center',
    form_login_transparency: 100,
    show_blog_btn: 0,
    // fondo_app: 'https://images.unsplash.com/photo-1533422902779-aff35862e462?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8aG9yaXpvbnRhbHxlbnwwfHwwfHx8MA%3D%3D',
    // fondo_app: 'assets/img/bg-cursalab.png',
    enrolled_courses_logo: 'assets/icon/cursos_inscritos.svg',
    completed_courses_logo: 'assets/icon/cursos_completados.svg',
    diplomas_logo: 'assets/icon/diplomas_obtenidas.svg',
    icono: 'assets/icon/favicon.png',
    id: 1,
    link_pbi: null,
    logo_cursalab: 'assets/img/logo_by_cursalab.svg',
    logo_app: 'assets/img/logo-cursalab.svg',
    titulo: 'Cursalab',
    titulo_login: 'Cursalab',
    url_app_web: null,
    template: 'template-default',
  };
  private networkObservable: Subscription;
  networkIsActive: boolean = true;
  language:string = "es";
  mobileMenuIsOpen = false;
  keyboardHidden = true;
  private keyboardSubscription: Subscription;
  private LoadingSubscription: Subscription;
  private orientationSubscription!: Subscription;
  isLandscape: boolean = false;
  loadingScreenIsActive: boolean = false;

  constructor(
    public platform: Platform,
    private titleService: Title,
    private up: UsuarioServiceProvider,
    private fp: FuncionesServiceProvider,
    public router: Router,
    private zone: NgZone,
    // private fcm: FCM,
    private Storage: Storage,
    public navCtrl: NavController,
    // private iab: InAppBrowser,
    // private LocalNotifications: LocalNotifications,
    private mp: MenuServiceProvider,
    private api: ApiService,
    // private statusBar: StatusBar,
    private ns: NotificacionService,
    private swUpdate: SwUpdate,
    private appRef: ApplicationRef,
    private alertCtrl: AlertController,
    @Inject(DOCUMENT) private document: any,
    private modalCtrl: ModalController,
    private networkService: ConexionServiceProvider,
    private offlineHttpService: OfflineService,
    private storageService: StorageService,
    private downloadFileService: DownloadFileService,
    private echoService: EchoService,
    public languageService: LanguageService,
    public syncService: SyncService,
    private loginMultiModuloService: LoginMultiModuloService,
    private appPlatformService:AppPlatformService,
    private keyboardService: KeyboardService,
    private orientationService: OrientationService,
    public capacitorSafe: CapacitorSafeService,
  )
  {
    if(environment.APP_MULTIMARCA && this.appPlatformService.isAppPlatform()) {
      SplashScreen.hide();
      this.router.navigate(['/splash-screen']);
    }

    this.up.configBrand.subscribe((res:any) => {
      this.config_empresa = res;
    });
    console.log('Ver. web: ', environment.WEB_VERSION);
    this.domain = this.document.location.hostname;
    this.addGoogleAnalyticsScript();

    if (
      swUpdate?.isEnabled &&
      (this.platform.is('desktop') || !this.platform.is('cordova'))
    ) {
      try {
        this.swUpdate?.versionUpdates.subscribe((event) => {
          if(event.type === "VERSION_READY") {
            console.log('current version::: ', event.currentVersion?.hash);
            console.log('available version::: ', event.latestVersion?.hash);
            console.log('available version appData::: ', event.latestVersion?.appData);
            if (
              this.webCurrentVersion &&
              this.webCurrentVersion === event.currentVersion?.hash &&
              this.webAvailableVersion &&
              this.webAvailableVersion === event.latestVersion?.hash
            ) {
              console.log('already informed');
            } else {
              this.webCurrentVersion = event.currentVersion?.hash;
              this.webAvailableVersion = event.latestVersion?.hash;
              console.log('reload message sw');
              this.unregisterServiceWorker();
              setTimeout(() => {
                window.location.reload()
              }, 2000);
              // this.reloadMessage();
            }

          }
        });
      } catch (error) {
        console.log(error)
      };

      const appIsStable$ = appRef.isStable.pipe(
        first((isStable) => isStable === true)
      );
      const everyTwoHour$ = interval(7200000);

      const everyTwoHourOnceAppIsStable$ = concat(appIsStable$, everyTwoHour$);

      this.checkUpdateInterval = everyTwoHourOnceAppIsStable$.subscribe(
        (intervalNumber) => {
          if (intervalNumber !== true) {
            try {
              swUpdate?.checkForUpdate().then((updateFound) => {
                console.log('checking for updates');
              });
            } catch (err) {
              console.error('Failed to check for updates', err);
            }
          }
        }
      );
    }

    this.mp.currentHideFooter.subscribe((state:any) => (this.fullscreen = state));

    this.ns.currentHideNotification.subscribe(
      (state:any) => {
        this.showNotification = state.isActive;
        this.showNotificationFrom = state.from;
      }
    );

    this.up.isLogged.subscribe((res:any) => {
      this.userIsLogged = res;
      if (this.userIsLogged) {
        // console.log("********************* userIsLogged *********************")
        this.data_usuario = JSON.parse(localStorage.getItem('user_data'));
        // console.log("data_usuario",this.data_usuario)
        if (this.data_usuario) {
          this.initials =
            this.data_usuario.nombre.charAt(0).toUpperCase() +
            this.data_usuario.apellido.charAt(0).toUpperCase();
          this.userFullName = this.data_usuario.full_name;
        };

        const finalAppTheme = JSON.parse(localStorage.getItem('config_ambiente') || 'null');
        const advancedCustomization = JSON.parse(localStorage.getItem('loggedCustomConfig') || 'null');
        //* config de ambiente especifica x workspace */
        // console.log("userIsLogged::", this.userIsLogged)
        // console.log({"finalAppTheme": finalAppTheme, "advancedCustomization": advancedCustomization});
        if (finalAppTheme) {
          this.loginMultiModuloService.handleThemeMergeAndApplyFinalTheme(advancedCustomization, finalAppTheme, false);
        };

        this.up.load_storage();

        setTimeout(() => {
          this.fp.cargarFunciones();
        }, 2200);
        this.userID = this.up.getIdUsuario;
        //validate impersonation session
        const configData = JSON.parse(localStorage.getItem('config_data') || "{}");
        if (configData.impersonation) {
          setTimeout(() => {
            this.showImpersonationBar = configData.impersonation.show_bar;
            this.impersonationBarTitle = configData.impersonation.show_title;
          }, 1000);
        }

        this.platform.ready().then(() => {
          if (this.appPlatformService.isAppPlatform()) {
            console.log('USUARIO LOGUEADO INIT HTTP OFFLINE SERVICE');
            // this.syncService.resetChecklistSyncStatus();

            setTimeout(() => {
                this.syncService.checkAndSyncIfNeeded();
                this.offlineHttpService.sendPendingOfflineRequests();
              }, 5000);
          }
        });

        const token = localStorage.getItem("token");

        this.echoService.setChannels(this.data_usuario, token, configData)
      } else {
        // console.log("********************* userNOTLogged *********************")
        this.languageService.setDefaultLanguage();
        this.initials = '';
        this.userFullName = '';

        this.showImpersonationBar = false;
        this.impersonationBarTitle = '';

        if (environment.APP_MULTIMARCA) {
          this.getMultibrandLoginConfig()
        } else {
          // console.log("********************* userNOTLogged *********************")
          this.getBrandedPlanThemeConfig(false);
        };

        this.syncService.removeDatabaseRef();
      }
    });

    //Add dynamic title for selected pages
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let title: string | any = this.getTitle(
          this.router.routerState,
          this.router.routerState.root
        );
        if (this.config_empresa) {
          title.length > 0
            ? titleService.setTitle(
                this.config_empresa.titulo
                  ? this.config_empresa.titulo
                  : 'Cursalab' + ' | ' + title[0]
              )
            : titleService.setTitle(
                this.config_empresa.titulo
                  ? this.config_empresa.titulo
                  : 'Cursalab'
              );
        }
        if (title.length > 0 && title[0] !== 'login') {
          const element = document.getElementsByClassName(
            'grecaptcha-badge'
          )[0] as HTMLElement;
          if (element) {
            element.style.visibility = 'hidden';
          }
        }
        const userJson = localStorage.getItem('user_data');
        const user = userJson !== null ? JSON.parse(userJson) : null;
        // if (user) {
        //   const nps = localStorage.getItem('nps')
        //     ? JSON.parse(localStorage.getItem('nps')!)
        //     : null;
        //   const date = localStorage.getItem('date_nps')
        //     ? JSON.parse(localStorage.getItem('date_nps')!)
        //     : { query: null, sent: null };
        //   const date_now = moment(new Date()).format('L');
        //   if (!nps || (nps && date.query !== date_now)) {
        //     const dni = user.dni;
        //     this.api
        //       .listNPS('app', '2', dni)
        //       .then((res: any) => {
        //         const date_nps = { query: date_now, sent: null };
        //         if (date.sent === date_now) {
        //           date_nps.sent = date.sent;
        //         }
        //         localStorage.setItem('date_nps', JSON.stringify(date_nps));
        //         localStorage.setItem('nps', JSON.stringify(res.data));
        //       })
        //       .catch((err:any) => {
        //         console.log(err);
        //         localStorage.setItem('nps', JSON.stringify([]));
        //       });
        //   }
        // }
        this.ns.changeShowNotification({isActive: false, from: ''});
      }
    });

    //Add analytics
    if (this.domain != 'localhost') {
      const navEndEvents$ = this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd)
      );

      navEndEvents$.subscribe((event: NavigationEnd) => {
        if (this.userID) {
          gtag('config', environment.GA_TRACKING_ID, {
            user_id: this.userID,
            page_path: event.urlAfterRedirects,
          });
        } else {
          gtag('config', environment.GA_TRACKING_ID);
          gtag('event', 'page_view', {
            page_path: event.urlAfterRedirects,
          });
        }
      });
    }

    this.platform.ready().then(async () => {
        // console.log('platform is ready');
      if (this.appPlatformService.isAppPlatform()) {
        if (this.appPlatformService.isIosHibridApp()) {
          this.platformIsIOS = true;
            //! todo
          // // let status bar overlay webview
          // this.statusBar.overlaysWebView(false);
          // // set status bar to white
          // this.statusBar.backgroundColorByHexString('#000000');
        };

        this.checkNewtworkStatus();
        if(!environment.APP_MULTIMARCA){
          await SplashScreen.hide();
        }
      };

      this.languageService.setDefaultLanguage();
    });

    if (this.appPlatformService.isAppPlatform()){
      App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
        this.zone.run(() => {
          try {
            const excludedRoutes: string[] = ["/validador-evaluacion", "/register", "/encuestas"];
            const slug = event.url;
            console.log("slug:: ",slug);
            const url = new URL(slug);
            const path = url.pathname;
            const query = url.search;

            if (excludedRoutes.includes(path)) {
              let modifiedUrl = url.href;
              if(path === "/validador-evaluacion") {
                modifiedUrl = this.encodeUrl(url);
              };
              this.downloadFileService.downloadMediaWithBrowser(modifiedUrl);
              return;
            }

            if (this.platform.is('ios')) {
              if (slug.indexOf(environment.CUSTOM_SCHEMA) > -1) {
                Browser.close();
                return;
              };
            };

            if (slug && path && path !== "//") {
              if(!this.userIsLogged) {
                console.log("---no logueado!!!");
                localStorage.setItem("pendingDeepLink", path + query);
              }
              this.mp.select_group.emit(null);
              this.router.navigateByUrl(path + query);
            };
          } catch (error) {
            console.log("error deeplink::", error);

          };
        });
      });
    };

  }

  ngOnInit() {
    this.subLanguageConfig();
    this.subKeyboardListener();
    this.checkLoadingScreenIsActive();

    //configuracion de ambiente por marca
    if (environment.APP_MULTIMARCA) {
      const finalAppTheme = JSON.parse(localStorage.getItem('config_ambiente') || 'null');
      const advancedCustomization = JSON.parse(localStorage.getItem('loggedCustomConfig') || 'null');
      //* config de ambiente especifica x workspace */
      // console.log("userIsLogged::", this.userIsLogged)
      // console.log({"finalAppTheme": finalAppTheme, "advancedCustomization": advancedCustomization});
      if (this.userIsLogged && finalAppTheme) {
        this.loginMultiModuloService.handleThemeMergeAndApplyFinalTheme(advancedCustomization, finalAppTheme, false);
      }


      let apiConnectors = this.api.getApiUrls;
      const apiUrlForBrand = localStorage.getItem('api_urls');
      if (apiConnectors.serviceBase === '' || !apiConnectors.serviceBase) {
        if (apiUrlForBrand) this.api.setApiUrls = JSON.parse(apiUrlForBrand);
      }

      const certificateUrlBase = this.up.getRutaBase;
      if (!certificateUrlBase && apiUrlForBrand) {
        this.up.genera_rutas();
      }
    } else {
      if (this.userIsLogged) {
        this.getBrandedPlanThemeConfig(true);
      }
    };

    this.unregisterServiceWorker();

    this.orientationSubscription = this.orientationService.isLandscape$.subscribe(
      (isLandscape) => {
        this.isLandscape = isLandscape;
        // console.log(
        //     "***isLandscape from app::",
        //     isLandscape,
        //     isLandscape &&
        //     (
        //       this.router?.url?.includes('escuela/') ||
        //       (this.router?.url?.includes('induccion/') && this.router?.url?.includes('tema/'))
        //     )
        //     && !this.router.url?.includes('beneficio/'),
        //     {
        //       escuela: this.router?.url?.includes('escuela/'),
        //       induccion:  this.router?.url?.includes('induccion/'),
        //       tema:  this.router?.url?.includes('tema/'),
        //       beneficio:  !this.router.url?.includes('beneficio/')
        //     }
        // )
      }
    );
  }

  subLanguageConfig() {
    this.languageService.getCurrentLang().subscribe(lang => {
      this.language = lang;
    });
  }

  unregisterServiceWorker() {
    if ('serviceWorker' in navigator) {
      try {
        navigator.serviceWorker.getRegistrations().then(registrations => {
          registrations.forEach(registration => registration.unregister());
        });
      } catch (error) {
        console.log(error);
      };
    };
  }

  checkNewtworkStatus() {
    console.log('*app.ts - initializeNetworkEvents!!!*');
    this.networkService.initializeNetworkEvents();
    this.networkObservable = this.networkService.onNetworkChange().subscribe((status: ConnectionStatus) => {
       this.networkIsActive = status == ConnectionStatus.Online;
       console.log("checkNewtworkStatus desde app.ts", this.networkIsActive)
    });
  }

  async reloadMessage() {
    // todo probar service worker
    const modalAvailable = await this.modalCtrl.create({
      component: MultipleOptionModalComponent,
      backdropDismiss: false,
      cssClass: 'reload-modal',
      componentProps: {
        firstButtonText: 'Actualizar ahora',
        secondButtonText: 'Actualizar más tarde',
        customStyle: 'w-10/12 sm:w-88 md:w-96 custom-reload-modal-width',
      },
    });
    await modalAvailable.present();

    const { data } = await modalAvailable.onWillDismiss();

    if (data.option === 'first') {
      console.log('reload');
      this.swUpdate
        .activateUpdate()
        .then(() => window.location.reload())
        .catch((error:any) => window.location.reload());
    }
  }

  async getBrandedPlanThemeConfig(userIsLogged) {
    const advancedCustomConfigInStorage = JSON.parse(localStorage.getItem('loggedCustomConfig') || 'null');
    let genericTheme;
    try {
      if(userIsLogged) {
        genericTheme = JSON.parse(localStorage.getItem('genericThemeByBrand') || 'null');
      } else {
        genericTheme = await this.api.getConfig();
        localStorage.setItem("genericThemeByBrand", JSON.stringify(genericTheme));
      };
      this.loginMultiModuloService.handleThemeMergeAndApplyFinalTheme(advancedCustomConfigInStorage, genericTheme, !environment.APP_MULTIMARCA);
    } catch (error) {
      console.log('ERROR - default config: ', error);
      this.loginMultiModuloService.handleThemeMergeAndApplyFinalTheme(advancedCustomConfigInStorage, this.defaultConfigData, !environment.APP_MULTIMARCA);
    }
  }



  // collect that title data properties from all child routes
  getTitle(state, parent):any {
    var data = [];

    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if (state && parent) {
      data.push(...this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }
  async logoutImpersonation() {
    await this.api
      .logout_token()
      .then((res) => {
        this.up.clearStorage();
        this.showImpersonationBar = false;
        this.impersonationBarTitle = '';
        this.router.navigate(['login']);
      })
      .catch((e) => {
        console.log(e.status, e.url);
      });
  }
  addGoogleAnalyticsScript() {
    if (this.domain != 'localhost') {
      let gtagScript: HTMLScriptElement = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src =
        'https://www.googletagmanager.com/gtag/js?id=' +
        environment.GA_TRACKING_ID;
      document.head.prepend(gtagScript);

      /** Disable automatic page view hit to fix duplicate page view count  **/
      gtag('config', environment.GA_TRACKING_ID, { send_page_view: false });
    }
  }

  encodeUrl(parsedUrl) {
    const apiUrl = parsedUrl.searchParams.get('api_url');
    const identificator = parsedUrl.searchParams.get('identificator');
    const course = parsedUrl.searchParams.get('course_id');
    const topic = parsedUrl.searchParams.get('topic_id');
    return parsedUrl.origin + parsedUrl.pathname + `?api_url=${encodeURIComponent(apiUrl)}&identificator=${identificator}&course_id=${course}&topic_id=${topic}`;
  }

  getMultibrandLoginConfig() {
    const origin =  this.fp.getLocationOrigin();
      this.api.getMultibrandLoginConfig(origin).subscribe(
        {
          next: ({data}) => {
            if(!this.userIsLogged) {
              const baseThemeToApply = (data?.color_primario_app || data?.logo_app) ? data : this.defaultConfigData;
              this.loginMultiModuloService.handleThemeMergeAndApplyFinalTheme(null, baseThemeToApply, false);
            };
          },
          error: (e) => {
            console.log("e::",e);
            this.loginMultiModuloService.handleThemeMergeAndApplyFinalTheme(null, this.defaultConfigData, false);
          }
        }
      );
  }

  checkLoadingScreenIsActive() {
    this.LoadingSubscription = this.fp.loadingScreenIsActive$.subscribe(isActive => {
      this.loadingScreenIsActive = isActive;
    });
  }

  ngOnDestroy() {
    if (this.checkUpdateInterval) {
      this.checkUpdateInterval.unsubscribe();
    }
    this.networkObservable?.unsubscribe();
    this.keyboardSubscription?.unsubscribe();
    this.orientationSubscription?.unsubscribe();
    this.LoadingSubscription?.unsubscribe();
  }

  onMenuIsOpen(isOpen) {
    this.mobileMenuIsOpen = isOpen;
  }

  subKeyboardListener() {
    this.keyboardSubscription = this.keyboardService.keyboardStatus$.subscribe( isHidden => {
        this.keyboardHidden = isHidden;
      }
    );
  }


}
